import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class RoleService {

  getRole(role_id) {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/role/" + role_id,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  listRoles() {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/roles",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  deleteRoles(ids) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/delete_roles",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        ids: ids
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setRole(name, accesses) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/role",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        name: name,
        accesses: accesses
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setAccess(name) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/access",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        name: name
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  listAccesses() {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/accesses",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  updateRole(role_id, name, accesses) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/role/api/v1/update_role",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        role_id: role_id,
        name: name,
        accesses: accesses
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }
}
